'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _preact = require('preact');

var _preactFela = require('preact-fela');

var _Core = require('../Core');

var _ChevronIcon = require('../Icon/ChevronIcon');

var _ChevronIcon2 = _interopRequireDefault(_ChevronIcon);

var _ArrowIcon = require('../Icon/ArrowIcon');

var _ArrowIcon2 = _interopRequireDefault(_ArrowIcon);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rules = function rules(_ref) {
  var isSubmenu = _ref.isSubmenu,
      mobile = _ref.mobile;

  var styleLink = {
    display: 'inline-flex',
    whiteSpace: 'nowrap',
    borderBottom: 'none',
    padding: '6px 0 6px 16px',
    height: 'auto',
    alignSelf: 'stretch',
    justifyContent: 'flex-start',
    color: isSubmenu || mobile ? '#666' : '#ffffff',
    width: isSubmenu ? '100%' : 'auto'
  };
  return {
    arrow: { marginLeft: 'auto' },
    navLink: _extends({
      display: 'flex',
      alignItems: 'center',
      height: '55px',
      padding: '0 16px',
      color: '#666',
      opacity: '1',
      outline: 'none',
      position: 'relative',
      fontSize: '14px',
      textAlign: 'left',
      fontWeight: 'normal',
      borderBottom: '1px solid #e0e0e0',
      textDecoration: 'none',
      transition: 'opacity 0.3s ease-in-out'
    }, isSubmenu && mobile ? styleLink : {}, {
      desktop: _extends({}, styleLink, {
        padding: '10px',
        marginRight: '5px'
      }),
      ':hover': {
        color: isSubmenu || mobile ? '#666' : '#ffffff',
        opacity: '0.75',
        textDecoration: 'none'
      },
      ':focus': {
        color: isSubmenu || mobile ? '#666' : '#ffffff',
        opacity: '0.9',
        textDecoration: 'none'
      }
    })
  };
};

var linkIconStyle = function linkIconStyle() {
  return {
    marginRight: '8px'
  };
};

var LinkIcon = (0, _preactFela.createComponent)(linkIconStyle, _ChevronIcon2.default, ['color', 'placement']);

var NavbarListLink = function NavbarListLink(props) {
  var mobile = props.mobile,
      menu = props.menu,
      config = props.config,
      styles = props.styles,
      isSubmenu = props.isSubmenu,
      handleClick = props.handleClick,
      _props$clicktype = props.clicktype,
      clicktype = _props$clicktype === undefined ? 'menu-lateral' : _props$clicktype;


  return (0, _preact.h)(
    _Core.Link,
    _extends({
      key: menu.key,
      href: menu.url,
      className: styles.navLink,
      onClick: function onClick(event) {
        return handleClick(event, menu);
      }
    }, (0, _utils.getAttrsGtm)(menu.label, { clicktype: clicktype })),
    [isSubmenu && (0, _preact.h)(LinkIcon, { color: '#666', placement: 'left' }), menu.label],
    menu.content && (0, _preact.h)(
      'div',
      { style: menu.content.style },
      menu.content.text
    ),
    mobile && !isSubmenu && (0, _preact.h)(_ArrowIcon2.default, { className: styles.arrow, color: config.color })
  );
};

exports.default = (0, _preactFela.connect)(rules)(NavbarListLink);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/components/Navbar/NavbarListLink.js
// module id = 192
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38